import {Three as THREE} from "@cm/material-nodes/three"

export const HELPER_OBJECTS_LAYER = 1
export const OVERLAY_OBJECTS_LAYER = 2

export const MIN_GIZMO_RADIUS = 5

export function configThreeHelperObjectLayers(object: THREE.Object3D, layer = HELPER_OBJECTS_LAYER) {
    object.traverse((child) => child.layers.set(layer)) // this also sets the layer for the object itself
}
